import type { LineItem, Tuple } from "@/interfaces/estimate-detail";

export const getLineItemComponentKey = (pageId: string, tuple: Tuple, lineItem: LineItem) =>
  `${pageId}---${!!tuple.isComplementOf}---${tuple.isComplementOf ?? tuple.tupleId}---${lineItem.lineItemId}---${lineItem.lineItem}---${lineItem.formula?.rawFormula ?? ""}`;
